module.exports = __webpack_public_path__ + "static/media/image1.d1b0f7df.png";